import { JobApplicationList } from "@container/employer-job-application-list";
import AuthLayout from "@container/layout/auth";

export default function EmployerJoApplicationPage() {
    return (
        <AuthLayout>
            <JobApplicationList />
        </AuthLayout>
    );
}
